export enum ShortUrlFlow {
  Join = "join",
  Book = "book",
  Cancel = "cancel",
  Reschedule = "reschedule",
}

export const SHORT_URL_FLOWS = Object.values(ShortUrlFlow);

export const SHORT_URL_SOURCES = ["email", "sms", "unknown"] as const;
export type ShortUrlSource = (typeof SHORT_URL_SOURCES)[number];

export const SHORT_URL_RESOLUTION_STATUSES = [
  "session_linked",
  "no_session_linked",
  "expired",
  "invalid_token",
  "error",
] as const;
export type ShortUrlResolutionStatus =
  (typeof SHORT_URL_RESOLUTION_STATUSES)[number];

export const SHORT_URL_RENDER_STATES = [
  "nothing_to_see",
  "early_waiting_room",
  "in_progress",
  "too_late",
  "session_ended",
  "already_rescheduled",
] as const;
export type ShortUrlRenderState = (typeof SHORT_URL_RENDER_STATES)[number];

export const SHORT_URL_FLOW_RESULTS = ["success", "error"] as const;
export type ShortUrlFlowResult = (typeof SHORT_URL_FLOW_RESULTS)[number];

export enum ShortUrlTerminalState {
  MeetRedirected = "meet_redirected",
  CancellationSubmitted = "cancellation_submitted",
  Rescheduled = "rescheduled",
  BookingCompleted = "booking_completed",
}

export const SHORT_URL_TERMINAL_STATES = Object.values(ShortUrlTerminalState);

export enum ShortUrlMeetRedirectTrigger {
  AutoT0 = "auto_t0",
  ManualJoinClick = "manual_join_click",
  Rejoin = "rejoin",
}

export const SHORT_URL_MEET_REDIRECT_TRIGGERS = Object.values(
  ShortUrlMeetRedirectTrigger,
);

export const SHORT_URL_MEET_REDIRECT_ERROR_TYPES = [
  "popup_blocked",
  "invalid_url",
  "unknown",
] as const;
export type ShortUrlMeetRedirectErrorType =
  (typeof SHORT_URL_MEET_REDIRECT_ERROR_TYPES)[number];
